module.exports = __webpack_public_path__ + "media/images/symbols/cuk-colored-f6ad99a56ddd912c520f2c3b5cc3859d.svg";